import { Route } from '@angular/router';
import { DeviceSelectionComponent } from '@features/activity-types/upgrade-device/device-selection/device-selection.component';
import { AccessoriesComponent } from '@features/shopping/accessories/accessories.component';
import { DeviceDetailsComponent } from '@features/shopping/device-details/device-details.component';
import { DeviceListComponent } from '@features/shopping/device-list/device-list.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const upgrade_device_routes: Route[] = [
  {
    path: 'device-selection',
    component: DeviceSelectionComponent,
    title: 'Select Device to Upgrade',
    data: { order_type_id: 2 }
  },
  {
    path: 'device-list',
    component: DeviceListComponent,
    title: 'Select New Device',
    data: { order_type_id: 2 }
  },
  {
    path: 'device-details',
    component: DeviceDetailsComponent,
    title: 'Customize Device',
    data: { order_type_id: 2 }
  },
  {
    path: 'accessories',
    component: AccessoriesComponent,
    title: 'Get Add Ons',
    data: { order_type_id: 2 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 2 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 2 }
  },
  {
    path: '',
    redirectTo: 'device-selection',
    pathMatch: 'full'
  }
];
